import { AppContext } from "../core/context";
import { MeshVisibility } from "../types/type_def";

export function showHighlight(ctx: AppContext, node: BABYLON.TransformNode) {
    if (node) {
        node.getChildMeshes(false).forEach(function (m) {
            m.overlayColor = BABYLON.Color3.FromHexString("#0461b0");
            m.overlayAlpha = 0.2;
            m.renderOverlay = true;
        });
    }
}

export function hideHighlight(ctx: AppContext, node: BABYLON.TransformNode) {
    if (node) {
        node.getChildMeshes(false).forEach(function (m) {
            m.renderOverlay = false;
        });
    }
}

export function hideAllHighlights(ctx: AppContext) {

    if (ctx.currentModule) {
        ctx.currentModule.entities.forEach(function (entity) {
            var entityNode = ctx.scene.getTransformNodeById(entity.id);
            hideHighlight(ctx, entityNode);
        });
    }
}

export function toggleMeshVisibility(ctx: AppContext, mesh: BABYLON.TransformNode, state: MeshVisibility) {

    if (mesh) {
        var childmeshes = mesh.getChildMeshes(false, function (m) { return !BABYLON.Tags.MatchesQuery(m, "connector") && !BABYLON.Tags.MatchesQuery(m, "entity")  });
        for (let m of childmeshes) {

            if (m.isAnInstance)
                continue;

            switch (state) {

                case MeshVisibility.VISIBLE: {
                    if (m.material) {
                        m.visibility = 1;
                        m.material.alpha = 1;
                        m.material.disableDepthWrite = false;
                        m.material.transparencyMode = 0;
                        m.material.alphaMode = 2;
                        m.material.needDepthPrePass = false;
                        m.renderingGroupId = 0;
                        m.setEnabled(true);
                    }
                }
                    break;
                case MeshVisibility.HIDDEN: {
                    if (m.material) {
                        m.visibility = 0;
                        m.material.alpha = 1;
                        m.material.disableDepthWrite = false;
                        m.material.transparencyMode = 0;
                        m.material.alphaMode = 0;
                        m.material.needDepthPrePass = false;
                        m.renderingGroupId = 0;
                        m.setEnabled(false);
                    }
                }
                    break;
                case MeshVisibility.HIGHLIGHTED: {
                    if (m.material) {
                        m.visibility = 1;
                        m.material.alpha = 1;
                        m.material.disableDepthWrite = false;
                        m.material.transparencyMode = 0;
                        m.material.alphaMode = 0;
                        m.material.needDepthPrePass = false;
                        m.renderingGroupId = 1;
                    }
                }
                    break;
                case MeshVisibility.FADED: {
                    if (m.material) {
                        m.renderingGroupId = 0;
                        m.material.alpha = 0.2;
                        m.material.disableDepthWrite = true;
                        m.material.transparencyMode = 1;
                        m.material.alphaMode = 7;
                        m.material.needDepthPrePass = true;
                    }
                }
                    break;

            }

            m.updateCache(true);
        };
    }
}
